import { ErrorMessage, Field as FormikField } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { Form as BsForm, InputGroup } from 'react-bootstrap'

function Field(props) {
  const { name, prepend, type, label, hint, ...otherProps } = props

  return (
    <BsForm.Group>
      <BsForm.Label className="font-weight-bold text-uppercase">
        {label ? label : name.toUpperCase().replace('_', ' ')}
      </BsForm.Label>
      <InputGroup>
        {prepend ? (
          <InputGroup.Prepend>
            <InputGroup.Text>{prepend}</InputGroup.Text>
          </InputGroup.Prepend>
        ) : null}
        <FormikField
          name={name}
          type={type}
          as={BsForm.Control}
          {...otherProps}
        />
      </InputGroup>
      <ErrorMessage
        name={name}
        component={BsForm.Text}
        className="text-danger"
      />
      {!!hint && <small>{hint}</small>}
    </BsForm.Group>
  )
}

Field.propTypes = {
  hint: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  name: PropTypes.string.isRequired,
  prepend: PropTypes.element,
  type: PropTypes.string,
}

Field.defaultProps = {
  type: 'text',
}

export default Field
